/** Load optional Horizon elements only when their markup is present, including section morphs. */
const configuration = document.getElementById('doriante-component-modules');

if (configuration) {
  const modules = JSON.parse(configuration.textContent || '{}');
  const selector = Object.keys(modules).join(',');
  const pending = new Map();

  const load = (element) => {
    const tag = element.localName;
    const url = modules[tag];
    if (!url || customElements.get(tag) || pending.has(url)) return;
    pending.set(url, import(url).catch((error) => {
      pending.delete(url);
      console.error(`Unable to load optional component ${tag}`, error);
    }));
  };

  const scan = (root) => {
    if (root.nodeType === 1 && root.matches(selector)) load(root);
    root.querySelectorAll?.(selector).forEach(load);
  };

  if (selector) {
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === 1 && node.isConnected) scan(node);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    scan(document);
  }
}
